import http from 'conversations-http/clients/http';
import invariant from '../../../utils/invariant';
export const getConnectedAccounts = ({
  inboxId
}) => {
  invariant(
  // @ts-expect-error parseInt can accept a string or number
  !isNaN(parseInt(inboxId, 10)), `InboxId must be a Number, got ${inboxId}`);
  return http.get(`/conversations-email/v1/connected-accounts/inbox/${inboxId}`);
};